import {ReactComponent as TPicon} from './icons/500_27.svg';
import {Divider} from '@mui/material';
import Record from './record.js'
import React from 'react';
import $ from 'jquery';

class Records extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      response: []
    };
    this.getRecords();
  }

  getRecords(){
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: 'poo_records',
        message_id: $('.poo_records').val()
      },
      cache: false,
      success: function(resp) {
        // console.log(resp['data'][0]);
        this.setState({response: resp['data'][0]});
      }.bind(this)
    });
  }

  isRecords(){
    if(this.state.response.length){
      return(
        <div id="column-names">
          <span />
          <p className="mobile-hidden">Start Time</p>
          <p className="mobile-hidden">End Time</p>
          <p>Duration (HH:MM)</p>
          <p>Poo Type</p>
          <span />
        </div>
      )
    } else {
      return(
        <h3>You have no previous wipes. Please see the instructions above to get wiping!</h3>
      )
    }
  }


  render() {
    return (
      <div className={"records-container"}>
      <Divider><TPicon className="tp-icon" width="100%" /></Divider>
        <h2>Your Previous Wipes</h2>
        {this.isRecords()}
        {this.state.response.reverse().map((rec) => rec['end_time'] ? <Record id = {rec['poo_id']} startTime = {rec['start_time']} endTime = {rec['end_time']} pooType = {rec['poo_type']} /> : null)}
      <Divider><TPicon className="tp-icon" width="100%" /></Divider>
      </div>
    );
  }
};

export default Records;
